








































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';

const cssPrefix = 'sw-nav-standalone-collapse-trigger';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwNavStandaloneCollapseTrigger extends SwExtendedVue {
  @Prop({ type: Boolean, required: true })
  collapsed: boolean;

  @Prop({ type: String, default: 'light' })
  theme: 'dark' | 'light';

  cssPrefix =  cssPrefix;
}
